import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuergschaftenComponent } from './components/buergschaften/buergschaften.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';
import { BuergschaftenSingleComponent } from './components/buergschaften/bgsch-single/bgsch-single.component';

const routes: Routes = [
    {path: RouteNames.BASE, component: BuergschaftenComponent},
    {path: RouteNames.SUB_PAGE, component: BuergschaftenComponent}
];

@NgModule({
    declarations: [
        BuergschaftenComponent,
        BuergschaftenSingleComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class BuergschaftenModule {
}
